// Define our own JsonObject type instead of importing from internal Angular module
export type JsonObject = Record<string, any>;

export class DataFilter {
  filter = new Map<string, number | string | boolean | string[] | number[]>();

  constructor() {
  }

  add(field: string, value?: number | string | boolean | string[] | number[]): Map<string, number | string | boolean | string[] | number[]> {
    this.filter.set(field, value);
    return this.filter;
  }

  remove(field: string): Map<string, number | string | boolean | string[] | number[]> {
    this.filter.delete(field);
    return this.filter;
  }

  getFilterAsJson(): JsonObject {
    let jsonObject: JsonObject = {};
    this.filter.forEach((value, key) => {
      jsonObject[key] = value
    });
    return jsonObject;
  }

  getFilterAsQueryString(): String {
    let query: string;
    this.filter.forEach((value, key) => {
      if (query) {
        query += '&' + key + '=' + value;
      } else {
        query = key + '=' + value;
      }
    });
    return query;
  }

  getKeys(): IterableIterator<String> {
    return this.filter.keys();
  }

  getValue(key: string): string | number | boolean | string[] | number[]{
    return this.filter.get(key);
  }

  hasKey(key: string ){
    return this.filter.has(key);
  }

  clear() {
    this.filter = new Map<string, number | string | boolean | string[] | number[]>();
  }
}
